import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  OnInit
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ChangePasswordComponent } from '../../../../auth/change-password/change-password.component';
import { FeathericonComponent } from "../../feathericon/feathericon.component";
import { buildAppRoutes } from '../../../../app.routes';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonModule, RouterModule, FeathericonComponent],   
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  profileName: string | null = '';
  public show: boolean = false;
  loginType:string|null = localStorage.getItem('login_Type')
  typesOfLogin:any = localStorage.getItem('TypesOfLogin')||{}

  constructor(private readonly router: Router, private readonly eRef: ElementRef) {}

  ngOnInit(): void {
    this.profileName = localStorage.getItem('profile_name');
    this.loginType = this.getValueFromId(this.loginType||'',this.typesOfLogin)
  }
  
  open() {
    this.show = !this.show;
  }
  getValueFromId(id: string, items: any): string {
    const Items = items ? JSON.parse(items) : null;
    return Items[id] || '';
  }

logOut() {
  localStorage.removeItem('rememberMe');
  localStorage.removeItem('token');
  localStorage.removeItem('calculatedExpiry');
  sessionStorage.removeItem('calculatedExpiry');
  localStorage.removeItem('loginTimestamp');
  localStorage.removeItem('sidebarItems');
  localStorage.removeItem('sideMenuList');
  localStorage.removeItem('lastActiveUrl');

  const redirectFlag = localStorage.getItem('redirect');

  this.router.resetConfig(buildAppRoutes());

  if (redirectFlag === 'N') {
    this.router.navigate(['/auth/login']);
  } else if (redirectFlag === 'Y') {
    // 👉 external redirect
    window.location.href = environment.myxenius;
  } else {
    // 👉 safe fallback
    this.router.navigate(['/auth/login']);
  }

  // optional cleanup (recommended)
  localStorage.removeItem('redirect');
}

  @HostListener('document:click', ['$event'])
  clickOutside(event: MouseEvent) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.show = false;
    }
  }
}
